import { useCallback, useState } from 'react';

/**
 * Чи монтується компонент разом із пререндереною сторінкою.
 *
 * Прод-збірка віддає готовий HTML (scripts/prerender.js), і перший екран
 * браузер малює ще до JavaScript. Анімація появи на кшталт
 * initial={{ opacity: 0 }} у такому разі нічого не «показує», а ховає вже
 * видиме: після завантаження скрипта заголовок, який людина щойно читала,
 * гасне і виринає знову через секунду-дві, а шапка на мить від'їжджає за
 * край екрана. Тому під час гідрації елементи першого екрана одразу стають
 * у фінальний стан. Для переходів усередині сайту анімація лишається: там
 * розмітка справді з'являється вперше.
 *
 * Прапорець ставить src/index.js перед hydrateRoot, знімає App після
 * першого коміту — усе, що змонтується пізніше, уже клієнтська навігація.
 */
let hydrating = false;

export const startHydration = () => {
  hydrating = true;
};

export const finishHydration = () => {
  hydrating = false;
};

/**
 * Повертає функцію для пропа initial: під час гідрації — false (без
 * анімації, одразу стан з animate), інакше — переданий початковий стан.
 * Рішення фіксується на монтуванні: framer-motion і так читає initial один раз.
 *
 *   const intro = useIntro();
 *   <motion.h1 initial={intro({ opacity: 0 })} animate={{ opacity: 1 }} />
 */
export const useIntro = () => {
  const [animate] = useState(() => !hydrating);
  return useCallback((from) => (animate ? from : false), [animate]);
};
